export const SeparateDot = () => {
  return <span className="sepration-dot"></span>;
};
